import React, { cloneElement, HTMLAttributes, isValidElement } from "react";
import clsx from "clsx";

type IconButtonOwnProps = {
  children: React.ReactElement;
};

export type IconButtonProps<C extends React.ElementType = "button"> = IconButtonOwnProps &
  Omit<React.ComponentPropsWithoutRef<C>, keyof IconButtonOwnProps | "component"> & {
    component?: C;
  };

export function IconButton<C extends React.ElementType = "button">({
  children,
  className,
  component,
  ...props
}: IconButtonProps<C>) {
  const Component = (component ?? "button") as React.ElementType;
  const iconContent =
    isValidElement<HTMLAttributes<HTMLElement>>(children) &&
    cloneElement(children, {
      ...children.props,
      className: clsx("!text-2xl", children.props.className),
    });
  return (
    <Component
      className={clsx(
        "p-2 size-10 rounded-full bg-transparent border-none cursor-pointer text-foreground",
        "focus-visible:outline-none",
        "focus-visible:ring focus-visible:ring-foreground focus-visible:ring-offset-page ring-contrast",
        className,
      )}
      {...props}
    >
      {iconContent}
    </Component>
  );
}
